import React, { useState, useRef } from 'react';

import { Box, Flex, Text, Button } from '@rebass/emotion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styled from '@emotion/styled';
import colors from '@theme/colors';

const Accordian = ({ content, id, title, className }) => {
  const [showAccordian, setShowAccordian] = useState('');
  const [height, setHeight] = useState('0px');

  const contentBox = useRef(null);

  function toggleAccordian() {
    setShowAccordian(showAccordian === '' ? 'active' : '');
    setHeight(showAccordian === 'active' ? '0px' : `${contentBox.current.scrollHeight}px`);
  }

  return (
    <Box className={`accordian-wrapper ${className}`} bg="white">
      <Button className={`accordian ${showAccordian}`} onClick={toggleAccordian}>
        <Flex alignItems="center" justifyContent="space-between">
          <Text fontWeight={600} fontSize={[2, 2, 2]} py={0} my={0}>
            {title}
          </Text>
          <Box color={colors.grayDark10} py={2} fontSize={[3, 4, 2]}>
            <FontAwesomeIcon icon={['far', 'chevron-down']} />
          </Box>
        </Flex>
      </Button>
      <Box ref={contentBox} className="accordian-content" style={{ maxHeight: `${height}` }}>
        <Box className="accordian-text" py={3} px={4} dangerouslySetInnerHTML={{ __html: content }}></Box>
      </Box>
    </Box>
  );
};

const styledAccordion = styled(Accordian)`
  width: 100%;
  transition: background-color 0.5s ease;
  border-bottom: 1px solid #f4f4f4;
  transition: background 0.3s ease;
  box-shadow: 0 1px 3px -2px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24);
  button {
    cursor: pointer;
    text-align: left;
    height: 100%;
    width: 100%;
    background: transparent;
    border: none;
    outline: none;
    transition: background 0.3s ease;
  }
  .accordian-content {
    overflow: hidden;
    transition: max-height 0.4s ease;
  }
  .active {
    background: #f9f9f9;
    transition: 0.6s ease;
  }
`;

export default styledAccordion;
